import { editorialPrinciples } from "@/mocks/suye";

const stats = [
  { v: "3000+", l: "累计追踪话题" },
  { v: "96%", l: "进展有来源可查" },
  { v: "0", l: "未经核实的单方爆料" },
];

export default function About() {
  return (
    <section id="about" className="relative overflow-hidden border-b border-background-200 bg-foreground-950 py-14 md:py-20">
      <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-primary-500/20 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-28 -left-20 h-72 w-72 rounded-full bg-accent-500/10 blur-3xl" />
      <div className="relative mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="mb-8 max-w-2xl">
          <span className="inline-flex items-center gap-2 text-xs font-bold tracking-[0.22em] text-accent-400 uppercase">
            <span className="h-px w-6 bg-accent-500" />
            关于宿野
          </span>
          <h2 className="mt-3 font-heading text-2xl font-black tracking-tight text-background-50 md:text-4xl">
            认真吃瓜，<span className="text-primary-500">更要吃得明白</span>
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-background-200/90 md:text-base">
            宿野吃瓜是一个把“围观”做成分寸感的内容社区：不追着情绪跑，而是把来龙去脉摆到你面前。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
          <div>
            <p className="font-heading text-2xl font-black leading-normal text-background-100 md:text-3xl md:leading-normal">
              “当我们决定做宿野时，就想清楚了一件事——<span className="text-accent-400">吃瓜可以热闹，但不能失真</span>。”
            </p>
            <div className="mt-6 space-y-4 text-[15px] leading-8 text-background-200/90">
              <p>
                宿野吃瓜诞生于一个朴素的想法：热点每天都有，信息散落在各处，多数人根本没空把每一条回应、每一次反转都追完。我们想做的，就是把这件事变得省力又清楚。
              </p>
              <p>
                于是我们专注做一件事——实时聚合、时间线还原。把文娱、科技、商业、社会、体育等领域的公开热议，整理成前排好懂的“现场”，让每个人都能快速坐上板凳看进展。
              </p>
            </div>
            <div className="mt-7 grid grid-cols-3 gap-4">
              {stats.map((s) => (
                <div key={s.l} className="rounded-2xl border border-background-50/10 bg-background-50/5 p-4 text-center">
                  <div className="font-heading text-2xl font-black text-background-50 md:text-3xl">{s.v}</div>
                  <div className="mt-1 text-[11px] leading-snug text-background-300">{s.l}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {editorialPrinciples.map((p, idx) => (
              <div
                key={p.title}
                className={
                  "rounded-2xl border border-background-50/10 p-5 " +
                  (idx % 2 === 0 ? "bg-background-50/[0.06]" : "bg-background-50/[0.03]")
                }
              >
                <span
                  className={
                    "flex h-11 w-11 items-center justify-center rounded-xl text-background-50 " +
                    (idx % 3 === 0 ? "bg-primary-500" : idx % 3 === 1 ? "bg-accent-600" : "bg-secondary-600")
                  }
                >
                  <i className={p.icon + " text-lg"} />
                </span>
                <h3 className="mt-4 font-heading text-base font-bold text-background-50">{p.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-background-200/90">{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}